export default{

    error:null,
    errorMessage:'',  
    isOK:false,  
    path:'',
    
}